<template>
  <div class="emsproduct">
    <Header />
    <Banner />
    <EmsProductPage />
    <Footer />
  </div>
</template>

<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import Header from '@/components/Header.vue'
import EmsProductPage from '@/components/EmsProductPage.vue'

export default {
  name: 'docproduct',
  components: {
    EmsProductPage,
    Header,
    Banner,
    Footer,
  }
}
</script>

<style lang="scss">

</style>